import { useMap } from 'react-leaflet';

function LocationButton({ position, zoom = 18 }) {
  const map = useMap();

  const handleClick = () => {
    if (position) {
      map.setView(position, zoom, {
        animate: true,
        duration: 1
      });
    }
  };

  return (
    <div className="leaflet-top leaflet-right" style={{ marginTop: '10px', marginRight: '10px' }}>
      <div className="leaflet-control" style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 5px rgba(0,0,0,0.2)', display: 'flex' }}>
        <button
          onClick={handleClick}
          className="location-button"
          title="Center on my location"
          disabled={!position}
          style={{
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            border: 'none',
            borderRight: '1px solid #f0f0f0',
            cursor: position ? 'pointer' : 'not-allowed',
            padding: '0 12px',
            margin: 0,
            outline: 'none',
            transition: 'all 0.2s ease',
            position: 'relative',
            overflow: 'hidden',
            minWidth: '36px',
            justifyContent: 'center',
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px'
          }}
          onMouseOver={(e) => {
            if (position) {
              e.currentTarget.style.backgroundColor = '#f8f9fa';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
          onMouseDown={(e) => position && (e.currentTarget.style.transform = 'translateY(1px)')}
          onMouseUp={(e) => position && (e.currentTarget.style.transform = 'translateY(0)')}
        >
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%)',
            pointerEvents: 'none',
            opacity: 0,
            transition: 'opacity 0.2s ease'
          }} className="location-button-shine"></div>
          
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke={position ? '#1a73e8' : '#ccc'} 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            style={{
              transition: 'all 0.3s ease',
              filter: position ? 'drop-shadow(0 1px 2px rgba(0,0,0,0.1))' : 'none',
              flexShrink: 0
            }}
          >
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
            {!position && (
              <path 
                d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"
                stroke="#ccc"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            )}
          </svg>
          
          <span style={{
            marginLeft: '8px',
            color: position ? '#1a73e8' : '#ccc',
            fontSize: '14px',
            fontWeight: 500,
            whiteSpace: 'nowrap',
            paddingRight: '12px',
            transition: 'color 0.3s ease'
          }}>
            Recenter
          </span>
        </button>
      </div>
    </div>
  );
}

export default LocationButton;
